import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { fetchUpgradeConfig } from 'pricing-pages-lib/api/fetchUpgradeConfig';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { getQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { SCREENS } from 'pricing-pages-ui/constants/tracking/Locations';
import { useEffect, useState } from 'react';
import { NavMarker } from 'react-rhumb';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import { POINT_TYPES } from 'ui-addon-upgrades/ums/types';
import { getHubAndTierFromApiName } from 'ui-addon-upgrades/ums/utils';
import { useAnchorLinkScroll } from '../../../hooks/htmlElementHooks';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';
import { useTrackRetail } from '../../../hooks/useTrackRetail';
import ProductInfoContainer from '../../common/ProductInfoContainer';
import SkeletonLoadWrapper from '../../common/loading/SkeletonLoadWrapper';
import WhyGoHubSpotSection from '../../free-tools-page/WhyGoHubSpotSection';
import { SuiteTiles } from '../../merch-card/SuiteTiles';
import ComparePlansLink from './ComparePlansLink';
import PersonalizedSuiteStarterFeatureTableContainer from './PersonalizedSuiteStarterFeatureTableContainer';
import SuiteStarterHeroBanner from './SuiteStarterHeroBanner';
import UpgradeModalHeroBanner from './UpgradeModalHeroBanner';
import FeatureInterestAndLimitUsageSection from './feature-interest/FeatureInterestAndLimitUsageSection';

const SuiteStarterPage = () => {
  useAnchorLinkScroll();
  useTrackRetail();
  useDocumentTitle('starterCrmSuite');
  const [upgradeConfig, setUpgradeConfig] = useState();
  const [showUpgradeModalContent, setShowUpgradeModalContent] = useState(false);
  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: SCREENS.SUITE_STARTER
    });
  }, []);
  useEffect(() => {
    const {
      upgradeSource
    } = getQueryParams();
    fetchUpgradeConfig(upgradeSource).then(config => {
      const {
        tier
      } = getHubAndTierFromApiName(config.apiNames[0]);

      if (tier === STARTER.toLocaleLowerCase() && config.pointType === POINT_TYPES.MODAL) {
        setUpgradeConfig(config);
        setShowUpgradeModalContent(true);
      } else {
        setUpgradeConfig(null);
      }
    }).catch(() => {
      setUpgradeConfig(null);
    });
  }, []);
  const isLoading = upgradeConfig === undefined;
  return /*#__PURE__*/_jsxs("div", {
    "data-selenium-id": "page-success",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "SUITE_STARTER_PAGE"
    }), /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
      isLoading: isLoading,
      heights: [705],
      widths: ['100%'],
      Content: showUpgradeModalContent ? UpgradeModalHeroBanner : SuiteStarterHeroBanner,
      contentProps: showUpgradeModalContent ? {
        upgradeConfig
      } : {}
    }), /*#__PURE__*/_jsxs(ProductInfoContainer, {
      style: {
        margin: 'auto'
      },
      children: [/*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: isLoading,
        Content: !showUpgradeModalContent ? SuiteTiles : undefined,
        contentProps: !showUpgradeModalContent ? {
          isFreeToStarter: true
        } : undefined
      }), /*#__PURE__*/_jsx(ComparePlansLink, {}), /*#__PURE__*/_jsx(FeatureInterestAndLimitUsageSection, {}), /*#__PURE__*/_jsx(PersonalizedSuiteStarterFeatureTableContainer, {}), /*#__PURE__*/_jsx(WhyGoHubSpotSection, {
        selectedNavItem: "suite-starter"
      })]
    })]
  });
};

export default SuiteStarterPage;